/* ============================================================
   Cèdre & Bloom — Shopify theme JS
   ============================================================ */

(function(){
  'use strict';

  /* ---------- HELPERS ---------- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* Availability is fail-open everywhere in this theme: something counts as
     purchasable unless it explicitly reports `available: false`. A missing
     field must never make the store refuse a sale. */
  const canBuy = v => !!v && v.available !== false;

  function formatMoney(cents){
    const fmt = window.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }
  window.formatMoney = formatMoney;

  /* ---------- CURSOR GLOW ----------
     Previously this ran an unconditional requestAnimationFrame loop for the
     lifetime of the page — 60fps of layout work forever, even with the mouse
     idle or the tab in the background. Now it only animates while the cursor
     is actually moving and parks itself once it settles. */
  const glow = $('#cursorGlow');
  const finePointer = window.matchMedia('(pointer:fine)').matches;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (glow && finePointer && !reduceMotion){
    let gx = 0, gy = 0, mx = 0, my = 0, running = false;
    const step = () => {
      const dx = mx - gx, dy = my - gy;
      gx += dx * 0.12; gy += dy * 0.12;
      glow.style.transform = `translate(${gx}px, ${gy}px) translate(-50%, -50%)`;
      // Park the loop once we're within half a pixel of the target.
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5){ running = false; return; }
      requestAnimationFrame(step);
    };
    const kick = () => { if (!running && !document.hidden){ running = true; requestAnimationFrame(step); } };
    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; kick(); }, { passive: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) running = false; });
  } else if (glow){
    glow.remove();
  }

  /* ---------- NAV SCROLL STATE ---------- */
  const nav = $('.nav');
  if (nav){
    const update = () => nav.classList.toggle('scrolled', window.scrollY > 30);
    update();
    window.addEventListener('scroll', update, {passive:true});
  }

  /* ---------- REVEAL ON SCROLL ---------- */
  if ('IntersectionObserver' in window){
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
    }, {threshold: 0.12, rootMargin: '0px 0px -60px 0px'});
    $$('.reveal, .reveal-stagger').forEach(el => io.observe(el));
  } else {
    $$('.reveal, .reveal-stagger').forEach(el => el.classList.add('in'));
  }

  /* ---------- DRAWER (mobile menu) ---------- */
  const drawer = $('#mobileDrawer');
  const drawerBg = $('#drawerBg');
  const burger = $('#burger');
  const drawerClose = $('#drawerClose');

  function openDrawer(){ if(drawer){drawer.classList.add('open'); drawerBg.classList.add('open'); document.body.classList.add('no-scroll');} }
  function closeDrawer(){ if(drawer){drawer.classList.remove('open'); drawerBg.classList.remove('open'); document.body.classList.remove('no-scroll');} }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerBg) drawerBg.addEventListener('click', closeDrawer);
  $$('[data-drawer-close]').forEach(a => a.addEventListener('click', closeDrawer));

  /* ---------- TOAST ---------- */
  const toastEl = $('#toast');
  const toastMsg = $('#toastMsg');
  let toastTimer;
  function toast(msg){
    if (!toastEl) return;
    toastMsg.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 2600);
  }
  window.cbToast = toast;

  /* ---------- FAQ ACCORDION ---------- */
  $$('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.parentElement;
      const wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ---------- WISHLIST (localStorage) ---------- */
  const WISH_KEY = 'cb_wishlist';
  function getWishlist(){
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; }
    catch(e){ return []; }
  }
  function setWishlist(arr){
    try { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); }
    catch(e){}
    const badge = $('#wishBadge');
    if (badge){
      badge.textContent = arr.length;
      badge.classList.toggle('show', arr.length > 0);
    }
  }
  function toggleWish(id){
    const list = getWishlist();
    const i = list.indexOf(id);
    if (i >= 0){ list.splice(i,1); setWishlist(list); return false; }
    list.push(id); setWishlist(list); return true;
  }
  // Initial render
  setWishlist(getWishlist());
  // Mark active hearts
  $$('.card-wish[data-product-id]').forEach(btn => {
    const id = btn.dataset.productId;
    if (getWishlist().indexOf(id) >= 0) btn.classList.add('active');
    btn.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      const isAdded = toggleWish(id);
      btn.classList.toggle('active', isAdded);
      toast(isAdded ? 'Saved to wishlist ❋' : 'Removed from wishlist');
    });
  });
  const wishBtn = $('#wishBtn');
  if (wishBtn) wishBtn.addEventListener('click', () => {
    const n = getWishlist().length;
    toast(n === 0 ? 'Your wishlist is waiting…' : `${n} piece${n>1?'s':''} saved`);
  });

  /* ---------- QUICK VIEW MODAL ---------- */
  const modalBg = $('#quickViewBg');
  const modalImg = $('#qvImg');
  const modalTitle = $('#qvTitle');
  const modalPrice = $('#qvPrice');
  const modalDesc = $('#qvDesc');
  const modalTag = $('#qvTag');
  const modalVariants = $('#qvVariants');
  const modalAdd = $('#qvAdd');
  const modalView = $('#qvView');
  const modalClose = $('#qvClose');
  let currentProduct = null;
  let currentVariantId = null;

  function closeModal(){ if(modalBg){ modalBg.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalBg) modalBg.addEventListener('click', e => { if (e.target === modalBg) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape'){ closeModal(); closeDrawer(); closeCartDrawer(); } });

  async function openQuickView(handle){
    if (!modalBg) return;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('not found');
      const p = await res.json();
      currentProduct = p;
      currentVariantId = (p.variants.find(canBuy) || p.variants[0]).id;
      modalTitle.textContent = p.title;
      modalDesc.innerHTML = p.description || '';
      modalTag.textContent = p.type || p.vendor || '';
      modalTag.style.display = modalTag.textContent ? 'inline-block' : 'none';
      // image
      const imgUrl = p.featured_image || (p.images && p.images[0]);
      if (imgUrl){ modalImg.innerHTML = `<img src="${imgUrl}" alt="${p.title}">`; }
      else { modalImg.innerHTML = ''; }
      // variants (if more than one)
      modalVariants.innerHTML = '';
      if (p.variants.length > 1){
        p.variants.forEach(v => {
          const b = document.createElement('button');
          b.className = 'variant-pill' + (v.id === currentVariantId ? ' active' : '') + (canBuy(v) ? '' : ' sold');
          b.textContent = v.title;
          b.disabled = !canBuy(v);
          b.addEventListener('click', () => {
            if (!canBuy(v)) return;
            currentVariantId = v.id;
            modalPrice.innerHTML = formatMoney(v.price);
            modalVariants.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
            b.classList.add('active');
            modalAdd.disabled = false;
            modalAdd.textContent = 'Add to Cart';
          });
          modalVariants.appendChild(b);
        });
      }
      // price
      const selected = p.variants.find(v => v.id === currentVariantId);
      modalPrice.innerHTML = formatMoney(selected.price);
      // links
      modalView.href = `/products/${p.handle}`;
      // Availability comes from `available` only. `inventory_quantity` is 0 for
      // products that don't track stock, which would falsely show "Sold out".
      modalAdd.disabled = !canBuy(selected);
      modalAdd.textContent = canBuy(selected) ? 'Add to Cart' : 'Sold out';
      modalBg.classList.add('open');
      document.body.classList.add('no-scroll');
    } catch(err){
      console.error('Quick view failed', err);
      toast('Could not load product');
    }
  }

  $$('.card-quick').forEach(b => {
    b.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      const handle = b.closest('.card').dataset.handle;
      if (handle) openQuickView(handle);
    });
  });

  if (modalAdd){
    modalAdd.addEventListener('click', async () => {
      if (!currentVariantId) return;
      modalAdd.disabled = true; modalAdd.textContent = 'Adding…';
      try {
        await addToCart(currentVariantId, 1);
        modalAdd.textContent = 'Added ✓';
        toast('Added to bag');
        setTimeout(() => {
          modalAdd.textContent = 'Add to Cart';
          modalAdd.disabled = false;
          closeModal();
          openCartDrawer();
        }, 800);
      } catch(e){
        modalAdd.textContent = 'Try again';
        modalAdd.disabled = false;
        toast('Could not add — try again');
      }
    });
  }

  /* ---------- CART (AJAX) ---------- */
  const cartDrawer = $('#cartDrawer');
  const cartDrawerBg = $('#cartDrawerBg');
  const cartBody = $('#cartBody');
  const cartFoot = $('#cartFoot');
  const cartCount = $('#cartCount');
  const cartBtn = $('#cartBtn');
  const cartClose = $('#cartClose');

  function openCartDrawer(){ if(cartDrawer){ cartDrawer.classList.add('open'); cartDrawerBg.classList.add('open'); document.body.classList.add('no-scroll'); } }
  function closeCartDrawer(){ if(cartDrawer){ cartDrawer.classList.remove('open'); cartDrawerBg.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  if (cartBtn) cartBtn.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); refreshCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerBg) cartDrawerBg.addEventListener('click', closeCartDrawer);

  // Route helpers with hard fallbacks — if window.routes is missing for any
  // reason, cart calls must still resolve rather than throwing TypeError.
  const R = window.routes || {};
  const CART_ADD    = (R.cart_add_url    || '/cart/add')    + '.js';
  const CART_CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  const CART_JS     = (R.cart_url        || '/cart')        + '.js';
  const CHECKOUT    = R.checkout_url     || '/checkout';
  const ALL_PRODUCTS= R.all_products_url || '/collections/all';

  async function cartFetch(url, payload){
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    let data = null;
    try { data = await res.json(); } catch(e){ /* empty body */ }
    if (!res.ok){
      // Shopify returns { status, message, description } on 4xx/5xx.
      const msg = (data && (data.description || data.message)) || `Request failed (${res.status})`;
      const err = new Error(msg);
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  }

  async function addToCart(variantId, qty, props){
    const id = parseInt(variantId, 10);
    if (!id || Number.isNaN(id)){
      throw new Error('No variant selected. Please choose an option.');
    }
    const item = { id: id, quantity: parseInt(qty, 10) || 1 };
    if (props) item.properties = props;
    const data = await cartFetch(CART_ADD, { items: [item] });
    await refreshCart();
    return data;
  }
  window.cbAddToCart = addToCart;

  async function changeCart(line, qty){
    await cartFetch(CART_CHANGE, { line: line, quantity: qty });
    await refreshCart();
  }

  function applyCart(cart){
    renderCart(cart);
    if (cartCount){
      cartCount.textContent = cart.item_count;
      cartCount.classList.toggle('show', cart.item_count > 0);
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  async function refreshCart(){
    try {
      const res = await fetch(CART_JS, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Could not read cart');
      applyCart(await res.json());
    } catch(e){ console.error(e); }
  }

  function renderCart(cart){
    if (!cartBody) return;
    if (!cart.items.length){
      cartBody.innerHTML = `
        <div class="cart-empty">
          <div class="ico"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 7h12l-1.5 12.5a2 2 0 01-2 1.5h-5a2 2 0 01-2-1.5L6 7z"/><path d="M9 7V5a3 3 0 016 0v2"/></svg></div>
          <p>Your bag is empty.</p>
          <a href="${ALL_PRODUCTS}" class="btn btn-ghost" style="margin-top:18px">Browse Jewelry</a>
        </div>`;
      cartFoot.style.display = 'none';
      return;
    }
    cartFoot.style.display = 'block';
    cartBody.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item">
        <div class="cart-item-img">${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}</div>
        <div class="cart-item-info">
          <h4>${item.product_title}</h4>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}
          ${item.properties && Object.keys(item.properties).length ? `<small>${Object.entries(item.properties).filter(([k,v]) => v && !k.startsWith('_')).map(([k,v])=>`${k}: ${v}`).join(' · ')}</small>` : ''}
          <div class="price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-qty">
            <button data-action="dec" data-line="${i+1}" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button data-action="inc" data-line="${i+1}" aria-label="Increase">+</button>
          </div>
        </div>
        <button class="cart-item-remove" data-action="rm" data-line="${i+1}" aria-label="Remove">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M6 18L18 6"/></svg>
        </button>
      </div>
    `).join('');
    cartFoot.innerHTML = `
      <div class="cart-total"><span>Subtotal</span><span>${formatMoney(cart.total_price)} <small>${(cart.currency || window.shopCurrency || '')}</small></span></div>
      <a href="${CHECKOUT}" class="btn btn-primary">Checkout <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg></a>
      <small class="note">Taxes and shipping calculated at checkout</small>
    `;
    cartBody.querySelectorAll('[data-action]').forEach(b => {
      b.addEventListener('click', async e => {
        const line = parseInt(b.dataset.line, 10);
        const item = cart.items[line-1];
        const action = b.dataset.action;
        let qty = item.quantity;
        if (action === 'inc') qty++;
        else if (action === 'dec') qty = Math.max(0, qty-1);
        else if (action === 'rm') qty = 0;
        try { await changeCart(line, qty); }
        catch(err){ toast('Could not update'); }
      });
    });
  }

  // Initial render from the Liquid-seeded cart — no network request on load.
  // Falls back to a fetch only if the bootstrap is somehow absent.
  if (window.cartBootstrap && Array.isArray(window.cartBootstrap.items)){
    applyCart(window.cartBootstrap);
  } else if (cartCount){
    refreshCart();
  }

  /* ============================================================
     PRODUCT PAGE — variant engine + add to cart
     ============================================================ */
  const productSection = $('[data-product-section]');
  const productForm = $('#productForm');

  function readJSON(selector, fallback){
    const el = $(selector, productSection || document);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); }
    catch(e){ console.error('Bad JSON in', selector, e); return fallback; }
  }

  if (productForm){
    const variants = readJSON('[data-product-variants]', []);
    const productMeta = readJSON('[data-product-meta]', {});
    // Keep the legacy global for any custom snippets that reference it.
    window.productVariants = variants;

    /* Availability is treated as FAIL-OPEN: a variant counts as purchasable
       unless it explicitly says `available: false`.

       This matters. If the availability field is ever missing from the variant
       payload, a strict `!variant.available` check silently marks every variant
       Sold Out and the store cannot sell anything, while the server-rendered
       HTML says otherwise. Failing open means the worst case is that Shopify
       rejects the add-to-cart and we show the customer the real reason —
       never a store that refuses money it could have taken. */
    const isPurchasable = canBuy;

    if (variants.length && !('available' in variants[0])){
      console.warn(
        '[theme] Variant payload is missing the `available` field. Availability ' +
        'is falling back to purchasable. Check the data-product-variants block ' +
        'in sections/main-product.liquid.'
      );
    }

    const variantIdInput = productForm.querySelector('[data-variant-id]');
    const addBtn = productForm.querySelector('[data-add-to-cart]');
    const addText = productForm.querySelector('[data-add-text]');
    const errorEl = productForm.querySelector('[data-form-error]');
    const priceCurrent = $('[data-price-current]', productSection);
    const priceCompare = $('[data-price-compare]', productSection);
    const stockLine = $('[data-stock-line]', productSection);
    const stickyText = $('[data-sticky-text]');
    const stickyBtn = $('#stickyBuyBtn');
    const mainImg = $('#productMainImg');

    const groups = $$('.variant-group', productForm);

    function showError(msg){
      if (!errorEl) { toast(msg); return; }
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function clearError(){
      if (errorEl){ errorEl.textContent = ''; errorEl.hidden = true; }
    }

    // Currently checked value for each option index
    function selectedOptions(){
      return groups.map(g => {
        const checked = g.querySelector('input[data-variant-option]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts){
      return variants.find(v => opts.every((val, i) => val === null || v.options[i] === val)) || null;
    }

    // Grey out option values that lead to no purchasable variant, given the
    // other currently-selected options.
    function updateAvailability(){
      const chosen = selectedOptions();
      groups.forEach((group, gi) => {
        $$('input[data-variant-option]', group).forEach(input => {
          const probe = chosen.slice();
          probe[gi] = input.value;
          // Only constrain by options before this one, so users can always
          // move sideways within a group without dead-ending.
          const candidates = variants.filter(v =>
            probe.every((val, i) => val === null || i > gi || v.options[i] === val)
          );
          const exists = candidates.length > 0;
          const purchasable = candidates.some(isPurchasable);
          const label = group.querySelector(`label[for="${input.id}"]`);
          if (!label) return;
          label.classList.toggle('is-unavailable', exists && !purchasable);
          label.classList.toggle('is-nonexistent', !exists);
        });
        const checked = group.querySelector('input[data-variant-option]:checked');
        const valueLabel = group.querySelector('[data-selected-value]');
        if (valueLabel && checked) valueLabel.textContent = checked.value;
      });
    }

    function updateMedia(variant){
      if (!variant || !mainImg) return;
      const mediaId = variant.featured_media_id
        || (variant.featured_media && variant.featured_media.id);
      if (!mediaId) return;
      const thumb = $$('.product-thumb').find(t => String(t.dataset.mediaId) === String(mediaId));
      if (thumb && thumb.dataset.img){
        $$('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        mainImg.src = thumb.dataset.img;
        if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
      } else if (variant.featured_image && variant.featured_image.src){
        mainImg.src = variant.featured_image.src;
      }
    }

    function setButtons(variant){
      const available = isPurchasable(variant);
      if (addBtn) addBtn.disabled = !available;
      if (addText) addText.textContent = variant
        ? (available ? 'Add to Cart' : 'Sold Out')
        : 'Unavailable';
      if (stickyBtn) stickyBtn.disabled = !available;
      if (stickyText) stickyText.textContent = available ? 'Add' : 'Sold Out';
    }

    function setStock(variant){
      if (!stockLine) return;
      if (!variant){ stockLine.innerHTML = '<span class="stock stock--out">Unavailable</span>'; return; }
      if (!isPurchasable(variant)){ stockLine.innerHTML = '<span class="stock stock--out">Sold out</span>'; return; }
      const tracked = variant.inventory_management === 'shopify';
      const denies = variant.inventory_policy === 'deny';
      const qty = variant.inventory_quantity;
      if (tracked && denies && qty > 0 && qty <= 5){
        stockLine.innerHTML = `<span class="stock stock--low">Only ${qty} left</span>`;
      } else {
        stockLine.innerHTML = '<span class="stock stock--in">In stock — ready to ship</span>';
      }
    }

    function setPrice(variant){
      if (!variant) return;
      if (priceCurrent) priceCurrent.innerHTML = formatMoney(variant.price);
      if (priceCompare){
        if (variant.compare_at_price && variant.compare_at_price > variant.price){
          priceCompare.innerHTML = formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.innerHTML = '';
          priceCompare.hidden = true;
        }
      }
    }

    function onVariantChange(){
      clearError();
      const variant = findVariant(selectedOptions());
      updateAvailability();
      setButtons(variant);
      setStock(variant);
      setPrice(variant);
      updateMedia(variant);

      if (variant){
        if (variantIdInput) variantIdInput.value = variant.id;
        try {
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        } catch(e){}
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
      } else if (variantIdInput){
        variantIdInput.value = '';
      }
    }

    productForm.addEventListener('change', e => {
      if (e.target.matches('input[data-variant-option]')) onVariantChange();
    });

    // Initial sync (also honours ?variant= in the URL)
    (function initVariant(){
      const params = new URLSearchParams(window.location.search);
      const wanted = params.get('variant');
      if (wanted){
        const v = variants.find(x => String(x.id) === String(wanted));
        if (v && groups.length){
          groups.forEach((g, i) => {
            const input = $$('input[data-variant-option]', g).find(x => x.value === v.options[i]);
            if (input) input.checked = true;
          });
        }
      }
      onVariantChange();
    })();

    /* ---------- QUANTITY ---------- */
    const qtyInput = productForm.querySelector('input[name=quantity]');
    if (qtyInput){
      productForm.querySelectorAll('.qty-selector button').forEach(b => {
        b.addEventListener('click', () => {
          const v = parseInt(qtyInput.value || '1', 10) || 1;
          qtyInput.value = b.dataset.dir === 'dec' ? Math.max(1, v - 1) : v + 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      qtyInput.addEventListener('blur', () => {
        const v = parseInt(qtyInput.value, 10);
        if (!v || v < 1) qtyInput.value = 1;
      });
    }

    /* ---------- SUBMIT ---------- */
    let submitting = false;
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      if (submitting) return;

      const variant = findVariant(selectedOptions());
      if (!variant){
        showError('That combination isn’t available. Please pick another option.');
        return;
      }
      if (!isPurchasable(variant)){
        showError('This option is sold out.');
        return;
      }

      submitting = true;
      clearError();
      addBtn.disabled = true;
      const original = addText ? addText.textContent : 'Add to Cart';
      if (addText) addText.textContent = 'Adding…';

      try {
        await addToCart(variant.id, qtyInput ? qtyInput.value : 1);
        if (addText) addText.textContent = 'Added ✓';
        toast('Added to bag');
        setTimeout(() => {
          if (addText) addText.textContent = original;
          addBtn.disabled = false;
          submitting = false;
          openCartDrawer();
        }, 700);
      } catch(err){
        console.error('Add to cart failed:', err);
        if (addText) addText.textContent = original;
        addBtn.disabled = false;
        submitting = false;
        showError(err.message || 'Could not add to bag. Please try again.');
        toast(err.message || 'Could not add to bag');
      }
    });
  }

  /* ============================================================
     CART PAGE — AJAX quantity + remove
     Links keep real hrefs so they still work with JS disabled.
     ============================================================ */
  const cartPage = $('[data-cart-page]');
  if (cartPage){
    const cartPageError = $('[data-cart-error]', cartPage);

    function cartPageShowError(msg){
      if (!cartPageError) { toast(msg); return; }
      cartPageError.textContent = msg;
      cartPageError.hidden = false;
      if (typeof cartPageError.scrollIntoView === 'function'){
        cartPageError.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    let busy = false;
    async function setLine(line, qty){
      if (busy) return;
      busy = true;
      cartPage.classList.add('is-loading');
      if (cartPageError) cartPageError.hidden = true;
      try {
        const cart = await cartFetch(CART_CHANGE, { line: line, quantity: qty });
        applyCart(cart);
        // Re-render the page rows from the authoritative cart response.
        window.location.reload();
      } catch(err){
        console.error('Cart update failed:', err);
        cartPageShowError(err.message || 'Could not update your bag.');
        busy = false;
        cartPage.classList.remove('is-loading');
      }
    }

    cartPage.addEventListener('click', e => {
      const step = e.target.closest('[data-cart-qty]');
      const rm = e.target.closest('[data-cart-remove]');
      if (step){
        e.preventDefault();
        const row = step.closest('[data-cart-row]');
        const input = row.querySelector('[data-cart-qty-input]');
        const cur = parseInt(input.value, 10) || 0;
        const max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
        let next = step.dataset.cartQty === 'inc' ? cur + 1 : cur - 1;
        if (next < 0) next = 0;
        if (max !== null && next > max){
          cartPageShowError(`Only ${max} available for this item.`);
          return;
        }
        setLine(parseInt(step.dataset.line, 10), next);
      } else if (rm){
        e.preventDefault();
        setLine(parseInt(rm.dataset.line, 10), 0);
      }
    });

    // Typing a quantity directly
    $$('[data-cart-qty-input]', cartPage).forEach(input => {
      input.addEventListener('change', () => {
        let v = parseInt(input.value, 10);
        if (Number.isNaN(v) || v < 0) v = 0;
        const max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
        if (max !== null && v > max){
          v = max;
          input.value = max;
          cartPageShowError(`Only ${max} available for this item.`);
        }
        setLine(parseInt(input.dataset.line, 10), v);
      });
    });
  }

  /* ---------- COLLECTION FILTERS (client-side scroll) ---------- */
  $$('.chip[data-filter]').forEach(c => {
    c.addEventListener('click', () => {
      const f = c.dataset.filter;
      c.parentElement.querySelectorAll('.chip').forEach(x => x.classList.remove('active'));
      c.classList.add('active');
      const cards = document.querySelectorAll('[data-cat]');
      cards.forEach(card => {
        const tags = (card.dataset.cat || '').toLowerCase().split('|');
        card.style.display = (f === 'all' || tags.indexOf(f) >= 0) ? '' : 'none';
      });
    });
  });

  /* ---------- BOOKING FORM (Shopify contact form) ---------- */
  // Pre-fill date min to tomorrow
  const dt = $('#bookingDate');
  if (dt){
    const t = new Date(); t.setDate(t.getDate()+1);
    dt.min = t.toISOString().split('T')[0];
  }

  /* ---------- STICKY ADD-TO-CART BAR (product page mobile) ---------- */
  const stickyBuy = $('#stickyBuy');
  const stickyBuyBtn = $('#stickyBuyBtn');
  const stickyPrice = $('#stickyPrice');
  const mainAddBtn = productForm ? productForm.querySelector('[type=submit]') : null;

  if (stickyBuy && mainAddBtn){
    let ticking = false;
    const updateStickyBar = () => {
      const rect = mainAddBtn.getBoundingClientRect();
      // show sticky bar when main button has scrolled off screen (above viewport)
      // OR is far below (initial state, before user scrolls into it)
      const belowFold = rect.top > window.innerHeight;
      const aboveFold = rect.bottom < 0;
      const show = belowFold || aboveFold;
      stickyBuy.classList.toggle('show', show);
      document.body.classList.toggle('has-sticky-buy', show);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking){ requestAnimationFrame(updateStickyBar); ticking = true; }
    }, {passive: true});
    updateStickyBar();
    window.addEventListener('resize', updateStickyBar);

    stickyBuyBtn.addEventListener('click', () => {
      if (!productForm) return;
      // requestSubmit() runs validation and fires a real submit event.
      // dispatchEvent(new Event('submit')) is not equivalent and skips it.
      if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit();
      else productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    // Sync the sticky price off the real variant change event.
    document.addEventListener('variant:change', e => {
      const v = e.detail && e.detail.variant;
      if (v && stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    });
  }

  /* ---------- PRODUCT GALLERY THUMBNAILS ---------- */
  $$('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const img = $('#productMainImg');
      if (!img || !thumb.dataset.img) return;
      $$('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      img.src = thumb.dataset.img;
      img.removeAttribute('srcset');
      if (thumb.dataset.alt) img.alt = thumb.dataset.alt;
    });
  });

  /* ---------- MOBILE NAV — active route, cart badge sync, menu open ---------- */
  const mobileNavCartBadge = $('#mobileNavCartBadge');
  // Sync the mobile-nav cart badge with the header cart badge (updated by refreshCart)
  if (cartCount && mobileNavCartBadge){
    const syncBadge = () => {
      mobileNavCartBadge.textContent = cartCount.textContent;
      mobileNavCartBadge.classList.toggle('show', cartCount.classList.contains('show'));
    };
    syncBadge();
    new MutationObserver(syncBadge).observe(cartCount, {
      childList: true, characterData: true, subtree: true, attributes: true
    });
  }

  // Mobile nav "Menu" button opens drawer
  const mobileNavMenu = $('#mobileNavMenu');
  if (mobileNavMenu) mobileNavMenu.addEventListener('click', openDrawer);

  // Mobile nav "Bag" opens the drawer instead of navigating (better UX)
  const mobileNavCart = $('#mobileNavCart');
  if (mobileNavCart){
    mobileNavCart.addEventListener('click', e => {
      if (window.innerWidth <= 820){
        e.preventDefault();
        openCartDrawer();
        refreshCart();
      }
    });
  }

  // Active-route highlight
  const mobileNav = $('#mobileNav');
  if (mobileNav){
    const path = location.pathname;
    let key = 'index';
    if (path === '/' || path === '') key = 'index';
    else if (path.startsWith('/collections') || path.startsWith('/products')) key = 'collection';
    else if (path.includes('book')) key = 'book';
    else if (path.startsWith('/cart')) key = 'cart';
    mobileNav.querySelectorAll('[data-route]').forEach(a => {
      if (a.dataset.route === key) a.classList.add('active');
    });
  }

  /* ---------- NEWSLETTER successful submit detection ---------- */
  // Shopify appends ?customer_posted=true on success
  if (location.search.indexOf('customer_posted=true') !== -1){
    const el = $('#newsSuccess');
    if (el) el.style.display = 'block';
  }
  if (location.search.indexOf('contact_posted=true') !== -1 || location.hash === '#contact_form-success'){
    const el = $('#bookingSuccess');
    if (el) el.style.display = 'flex';
  }

})();
